<div class="p-6 max-w-2xl mx-auto">
  <div class="flex items-center justify-center relative mb-8">
    <div class="absolute left-0">
      <app-metro-button variant="text" (clicked)="cancel()">
        <div class="flex items-center gap-2">
          <app-metro-icon [svg]="iconBack" size="20"></app-metro-icon>
          <span class="hidden md:inline">{{ '::Back' | abpLocalization }}</span>
        </div>
      </app-metro-button>
    </div>
    <h3 class="text-2xl font-bold text-metro-blue-secondary">{{ (isViewMode ? '::ViewCoupon' : (isEditMode ? '::EditCoupon' : '::AddCoupon')) | abpLocalization }}</h3>
  </div>

  <div class="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Code -->
        <app-metro-form-input
          [label]="'::Code' | abpLocalization"
          [placeholder]="'::EnterCouponCode' | abpLocalization"
          formControlName="code"
          [error]="getErrorMessage('code')"
        ></app-metro-form-input>

        <!-- Active -->
        <div class="flex items-center mt-8">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" formControlName="isActive" class="w-4 h-4 rounded border-gray-300 text-metro-blue focus:ring-metro-blue">
            <span class="text-sm font-medium text-gray-700">{{ '::IsActive' | abpLocalization }}</span>
          </label>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Discount Type -->
        <app-metro-form-select
          [label]="'::DiscountType' | abpLocalization"
          [options]="discountTypeOptions"
          formControlName="discountType"
          [error]="getErrorMessage('discountType')"
          [allowSearch]="false"
          [allowClear]="false"
        ></app-metro-form-select>

        <!-- Discount Value -->
        <app-metro-form-input
          [label]="(form.get('discountType')?.value == 0 ? '::DiscountValuePercent' : '::DiscountValue') | abpLocalization"
          type="number"
          formControlName="discountValue"
          [error]="getErrorMessage('discountValue')"
        ></app-metro-form-input>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Start Date -->
        <app-metro-form-input
          [label]="'::StartDate' | abpLocalization"
          type="datetime-local"
          formControlName="startDate"
          [error]="getErrorMessage('startDate')"
        ></app-metro-form-input>

        <!-- End Date -->
        <app-metro-form-input
          [label]="'::EndDate' | abpLocalization"
          type="datetime-local"
          formControlName="endDate"
          [error]="getErrorMessage('endDate')"
        ></app-metro-form-input>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Max Uses -->
        <app-metro-form-input
          [label]="'::MaxUses' | abpLocalization"
          type="number"
          [placeholder]="'::Unlimited' | abpLocalization"
          formControlName="maxUses"
          [error]="getErrorMessage('maxUses')"
        ></app-metro-form-input>

        <!-- Minimum Amount -->
        <app-metro-form-input
          [label]="'::MinimumAmount' | abpLocalization"
          type="number"
          [placeholder]="'::NoMinimum' | abpLocalization"
          formControlName="minimumAmount"
          [error]="getErrorMessage('minimumAmount')"
        ></app-metro-form-input>

        <!-- Sommeliers -->
        <div class="col-span-full">
          <app-metro-form-select
            [label]="'::AssignedSommelier' | abpLocalization"
            [options]="sommelierOptions"
            formControlName="sommelierIds"
            [multiple]="true"
            [placeholder]="'::All' | abpLocalization"
          ></app-metro-form-select>
        </div>

        <!-- Wines -->
        <div class="col-span-full">
          <app-metro-form-select
            [label]="'::AssignedWines' | abpLocalization"
            [options]="wineOptions"
            formControlName="wineIds"
            [multiple]="true"
            [placeholder]="'::All' | abpLocalization"
          ></app-metro-form-select>
        </div>

        <!-- Clients -->
        <div class="col-span-full">
          <app-metro-form-select
            [label]="'::AssignedClients' | abpLocalization"
            [options]="clientOptions"
            formControlName="clientIds"
            [multiple]="true"
            [placeholder]="'::All' | abpLocalization"
          ></app-metro-form-select>
        </div>
      </div>

      <div class="flex justify-between items-center pt-4 mt-6 border-t border-gray-50">
        <div>
          <app-metro-button
            *ngIf="isEditMode && !isViewMode"
            variant="danger"
            text="Eliminar cupón"
            (clicked)="deleteCoupon()"
            type="button"
          ></app-metro-button>
        </div>
        <div class="flex justify-end gap-3">
          <app-metro-button
            variant="text"
            [text]="'::Cancel' | abpLocalization"
            (clicked)="cancel()"
            type="button"
          ></app-metro-button>
          <app-metro-button
            *ngIf="!isViewMode"
            variant="secondary"
            [text]="(isEditMode ? '::Update' : '::CreateCoupon') | abpLocalization"
            type="submit"
          ></app-metro-button>
        </div>
      </div>
    </form>
  </div>
</div>
